import { useFlags } from '@flagsmith/flagsmith/react';
import type { FeatureFlagName } from './feature-flags.constants';

export const useFeatureFlag = (name: FeatureFlagName) =>
  useFlags<FeatureFlagName>([name])[name]?.enabled === true;
